import * as React from 'react';

import { RadioGroupStateProps } from './RadioGroup.types';
import RadioGroupContext from './RadioGroupContext';

export default function useRadioGroup(): RadioGroupStateProps | undefined {
  return React.useContext(RadioGroupContext);
}
